import { CALL_API } from '../../../middleware/api';
import { newsItem } from '../../../schema';

const LOAD = 'news/LOAD';
const LOAD_SUCCESS = 'news/LOAD_SUCCESS';
const LOAD_FAIL = 'news/LOAD_FAIL';

const LOAD_ONE = 'news/LOAD_ONE';
const LOAD_ONE_SUCCESS = 'news/LOAD_ONE_SUCCESS';
const LOAD_ONE_FAIL = 'news/LOAD_ONE_FAIL';

export const PAGINATION_TYPES = [LOAD, LOAD_SUCCESS, LOAD_FAIL];


export const fetchItem = id => (dispatch, getState) => {
  if (id in getState().entities.news) {
    return;
  }

  return dispatch({
    [CALL_API]: {
      types: [LOAD_ONE, LOAD_ONE_SUCCESS, LOAD_ONE_FAIL],
      endpoint: `articles/${id}/`,
      schema: newsItem,
      method: 'GET'
    }
  });
};

const fetchPage = endpoint => ({
  [CALL_API]: {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    endpoint,
    schema: [newsItem],
    method: 'GET'
  }
});

export const loadPage = (loadMore = false) => (dispatch, getState) => {
  const {
    nextPageUrl = 'articles/',
    pageCount = 0
  } = getState().pagination.news || {}

  if (pageCount > 0 && !loadMore) {
    return null
  }

  return dispatch(fetchPage(nextPageUrl))
};



// WEBPACK FOOTER //
// ./src/redux/modules/news/index.js